import { render, staticRenderFns } from "./AccordianItem.vue?vue&type=template&id=374d8252"
import script from "./AccordianItem.vue?vue&type=script&lang=js"
export * from "./AccordianItem.vue?vue&type=script&lang=js"
import style0 from "./AccordianItem.vue?vue&type=style&index=0&id=374d8252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports